<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="[]" :searchs="searchs" :form-fields="formFields"
                  :permission="permission"/>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";

export default {
  name: "LiveMonitor",
  components: {CommonTable},
  data() {
    return {
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      },{
        name: 'phone',
        placeholder: '手机号',
        type: 'input'
      } ],
      permission: {
        add: 'liveMonitor:add',
        update: 'liveMonitor:update',
        delete: 'liveMonitor:delete',
        deleteBatch: 'liveMonitor:deleteBatch'
      },
      url: {
        get: '/liveMonitor/listByCondition',
        add: '/liveMonitor/add',
        // update: '/liveMonitor/update',
        delete: '/liveMonitor/delete/',
        delete_batch: '/liveMonitor/deleteBatch',
        status: '/liveMonitor/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select',
        },
        width: '',
      },{
        field: 'phone',
        label: '用户',
        show: true,
        width: '',
      },
        {
          field: 'liveRoomName',
          label: '直播间名称',
          show: true,
          width: '',
        },
        {
          field: 'liveRoomUrl',
          label: '直播间路径',
          show: true,
          width: '',
        },{
          field: 'liveStatus',
          label: '直播间状态',
          show: {
            type: 'tag',
            tags: [{
              key: 0,
              value: '未直播',
              type: 'danger'
            },{
              key: 1,
              value: '直播中',
              type: 'success'
            }]
          },
          width: '',
        },{
          field: 'remark',
          label: '备注',
          show: true,
          width: '',
        },{
          field: 'liveId',
          label: '官方直播间ID',
          show: true,
          width: '',
        }, {
          field: 'createTime',
          label: '时间',
          show: true,
          width: '',
        },
        // ,
        // {
        //   field: 'recordStatus',
        //   label: '录制状态',
        //   show: {
        //     type: 'tag',
        //     tags: [{
        //       key: 0,
        //       value: '等待录制',
        //       type: 'danger'
        //     },{
        //       key: 1,
        //       value: '录制中',
        //       type: 'success'
        //     }]
        //   },
        //   width: '',
        // }
        ],
      operate: [],
      formFields: {
        addTitle: '直播片段',
        updateTitle: '直播片段',
        model: [
        //     {
        //   field: 'agentId',
        //   label: '代理：',
        //   type: 'select',
        //   placeholder: '请选择代理',
        //   rules:[{required: true, message: '请选择代理', trigger: 'blur'}],
        //   selectUrl: '/agent/getAll',
        //   selectData: [],
        //   add: true,
        //   update: true,
        //   filterable: true,
        // },{
        //   field: 'liveRoomId',
        //   label: '直播间Id：',
        //   type: 'select',
        //   placeholder: '请选择代理',
        //   rules:[{required: true, message: '请选择代理', trigger: 'blur'}],
        //   selectUrl: '/liveRoom/getAll',
        //   selectData: [],
        //   add: true,
        //   update: true,
        //   filterable: true,
        // },{
        //   field: 'phone',
        //   label: '用户',
        //   type: 'input',
        //   placeholder: '手机号',
        //   rules: [{message: '请输入手机号', trigger: 'blur', required: true}],
        //   add: true,
        //   update: true,
        // }, {
        //   field: 'liveRoomName',
        //   label: '直播间名称',
        //   type: 'input',
        //   placeholder: '直播间名称',
        //   rules: [{message: '请输入直播间名称', trigger: 'blur', required: false}],
        //   add: true,
        //   update: true,
        // },  {
        //   field: 'clipCoverImageUrl',
        //   label: '片段封面URL',
        //   type: 'input',
        //   placeholder: '片段封面URL',
        //   rules: [{message: '请输入片段封面URL', trigger: 'blur', required: false}],
        //   add: true,
        //   update: true,
        // }, {
        //   field: 'liveMonitorName',
        //   label: '剪辑名称',
        //   type: 'input',
        //   placeholder: '剪辑名称',
        //   rules: [{message: '请输入剪辑名称', trigger: 'blur', required: false}],
        //   add: true,
        //   update: true,
        // },  {
        //   field: 'liveMonitorUrl',
        //   label: '剪辑保存URL',
        //   type: 'input',
        //   placeholder: '剪辑保存URL',
        //   rules: [{message: '请输入剪辑保存URL', trigger: 'blur', required: false}],
        //   add: true,
        //   update: true,
        // },{
        //   field: 'tags',
        //   label: '标签',
        //   type: 'input',
        //   placeholder: '标签',
        //   rules: [{message: '请输入标签', trigger: 'blur', required: false}],
        //   add: true,
        //   update: true,
        // },{
        //   field: 'videoDuration',
        //   label: '剪辑视频时长',
        //   type: 'input',
        //   placeholder: '剪辑视频时长',
        //   rules: [{message: '请输入剪辑视频时长', trigger: 'blur', required: false}],
        //   add: true,
        //   update: true,
        // }, {
        //   field: 'liveTime',
        //   label: '直播时间',
        //   type: 'input',
        //   placeholder: '直播时间',
        //   rules: [{message: '请输入直播时间', trigger: 'blur', required: false}],
        //   add: true,
        //   update: true,
        // }
        ],
      }
    }
  }
}
</script>

<style scoped>

</style>
